import type { AwardAnnouncementContent } from '../homeAwardAnnouncement';
import { homeAwardPoster } from '../homeAwardPoster';

export default {
  lang: 'ko',
  eyebrow: '기업 소식',
  title: 'Gold Label Global, 2026년 아시아·태평양 금 거래 선도 브랜드로 선정',
  date: '2026년 9월 22일',
  location: '홍콩',
  award: homeAwardPoster.kr.title,
  summary: 'Gold Label Global Limited는 홍콩에서 열린 글로벌 금융산업 박람회에서 “아시아·태평양 금 거래 선도 브랜드” 상을 수상했습니다. 이번 수상은 귀금속 거래 서비스, 전문 역량, 브랜드 개발에 대한 회사의 지속적인 투자를 인정한 결과입니다.',
  introduction: [
    '2026년 9월 22일, 홍콩에서 글로벌 금융산업 박람회가 개최되었습니다. 금융 거래, 금융 기술, 자산 관리 및 관련 서비스 분야의 기관과 전문가, 실무자들이 모여 글로벌 시장 동향, 금융 기술 혁신, 금융 생태계 전반의 발전 방향에 대해 의견을 나누었습니다.',
    'Gold Label Global Limited는 이번 행사에 참가했으며 시상식에서 “아시아·태평양 금 거래 선도 브랜드” 상을 받았습니다.',
    '이번 박람회 참가와 수상은 Gold Label Global 브랜드의 발전 과정에서 중요한 이정표가 되었습니다. 또한 귀금속 분야에 대한 회사의 꾸준한 투자, 전문 서비스, 브랜드 구축 성과가 업계에서 한층 더 인정받았음을 보여 줍니다.',
  ],
  sections: [
    {
      heading: '귀금속 분야의 전문 역량을 보여 주는 수상',
      paragraphs: [
        '금융 시장이 더욱 세계화되고 전문화되며 기술 중심으로 발전함에 따라, 투자자들은 거래 환경, 서비스 역량, 위험 관리, 전문 기준에 대해 더 높은 수준을 요구하고 있습니다.',
        '귀금속 거래 서비스에 주력하는 금융 브랜드인 Gold Label Global은 시장 전문성을 심화하고, 거래 서비스와 기술, 고객 경험, 브랜드 개발 전반에 걸쳐 종합적인 서비스 체계를 강화하고 있습니다.',
        '“아시아·태평양 금 거래 선도 브랜드” 상은 금 및 귀금속 거래 분야에서 회사가 이룬 지속적인 발전을 인정하는 이정표입니다. Gold Label Global에 이 상은 영예인 동시에 책임이기도 합니다.',
        '업계의 모든 인정은 전문 기준을 오랫동안 지켜 온 노력에 기반합니다. 끊임없이 변하는 글로벌 금융 시장에서 Gold Label Global은 안정성, 전문성, 장기적인 관점을 중심에 두고 서비스 역량을 높이며, 고객과 시장에 더욱 성숙한 브랜드의 모습을 보여 줄 것입니다.',
      ],
    },
    {
      heading: '업계의 역량을 모으고 글로벌 금융 생태계를 연결',
      paragraphs: [
        '글로벌 금융산업 박람회는 금융기관, 업계 전문가, 유통 파트너, 전문 투자자가 모여 동향을 논의하고 자원을 연결하며 혁신 성과를 공유하는 장을 마련했습니다.',
        'Gold Label Global은 전시 부스, 현장 대화, 업계 교류를 통해 여러 시장의 금융 실무자 및 파트너들과 심도 있는 의견을 나누었습니다.',
        '교류 주제는 업계 동향, 시장 수요, 금융 기술의 발전, 귀금속 거래 서비스의 고도화에 이르렀습니다. 이러한 대화는 회사가 글로벌 금융 시장의 변화를 더 깊이 이해하고, 업계 자원을 연결하며 향후 협력을 강화할 새로운 기회를 만드는 데 도움이 되었습니다.',
        'Gold Label Global에 업계 박람회 참가는 브랜드를 소개하는 것 이상의 의미가 있습니다. 시장, 업계 관계자, 파트너들과의 꾸준한 대화는 회사가 글로벌 금융 생태계와 긴밀하게 연결되고, 변화하는 환경에서도 민감한 통찰력과 개방성, 전문성을 유지하도록 돕습니다.',
      ],
    },
    {
      heading: '귀금속 전문성을 심화하고 전문 서비스를 강화',
      paragraphs: [
        '홍콩에 기반을 둔 Gold Label Global Limited는 금, 은 및 기타 귀금속 거래에 지속적으로 집중하고 있습니다.',
        '홍콩 금은업무역장 골드그룹의 일원으로서, 회사는 귀금속 사업을 발전시키고 거래 환경, 기술 지원, 고객 서비스, 시장 교육에 대한 투자를 이어 가고 있습니다.',
        'Gold Label Global은 국제 금융 중심지인 홍콩의 강점을 바탕으로 아시아·태평양 및 세계 시장과의 연결을 강화하고, 여러 지역의 고객에게 더욱 전문적이고 효율적인 귀금속 거래 경험을 제공하고자 합니다.',
        '회사는 금융 기술의 발전도 꾸준히 살피고 있습니다. 디지털 도구, 금융 기술, 지능형 기술의 활용을 모색하며 향후 성장을 뒷받침할 보다 탄탄한 기술 기반과 서비스 역량을 구축하고 있습니다.',
        '제품과 서비스, 브랜드와 시장, 거래 경험, 금융 교육, 업계와의 대화 전반에 걸쳐 Gold Label Global은 더욱 완성도 높은 브랜드 생태계를 차근차근 만들어 가고 있습니다.',
      ],
    },
    {
      heading: '전문 기준을 장기적 가치의 원천으로 삼아 전진',
      paragraphs: [
        '수상은 한 단계의 성장을 인정하는 동시에 다음 여정의 시작을 알립니다. 글로벌 금융산업 박람회 참가와 “아시아·태평양 금 거래 선도 브랜드” 수상은 귀금속 분야에 대한 Gold Label Global의 의지를 더욱 확고하게 했습니다.',
        'Gold Label Global은 앞으로도 홍콩을 기반으로 세계 시장과 연결될 것입니다. 전문 역량과 고객의 요구를 지침으로 거래 서비스를 개선하고, 금융 기술의 활용을 심화하며, 투자자 교육과 브랜드 개발을 지원해 변화하는 글로벌 금융 시장에서 장기적 가치를 추구할 것입니다.',
        '홍콩에서 출발해 세계 시장과 함께합니다.',
      ],
    },
  ],
  readMore: '전문 읽기',
  readLess: '전문 접기',
} satisfies AwardAnnouncementContent;
